// src/modules/Sidebar/Sidebar.js
import React, { useContext, useState, useRef, useEffect } from 'react';
import { ChatContext } from '../../context/ChatContext.js';
import { Link } from 'react-router-dom';
import { FaPlus, FaSearch, FaBook, FaRobot, FaBrain, FaUserTie, FaStar, FaEllipsisV, FaTrash, FaSave } from 'react-icons/fa';
import './Sidebar.css';

function Sidebar({ onSelect }) {
  const { history, deleteChat, updateChat, currentPrompt } = useContext(ChatContext);
  const [menuOpenId, setMenuOpenId] = useState(null);
  const menuRef = useRef(null);

  const toggleMenu = (id) => {
    setMenuOpenId(menuOpenId === id ? null : id);
  };

  const handleDelete = (id) => {
    deleteChat(id);
    setMenuOpenId(null);
  };

  const handleSave = (id) => {
    updateChat(id, { saved: true });
    setMenuOpenId(null);
  };

  // Close menu on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpenId(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Filter or highlight history items based on currentPrompt substring match
  const filteredHistory = currentPrompt
    ? history.filter(chat => chat.name.toLowerCase().includes(currentPrompt.toLowerCase()))
    : history;

  return (
    <aside id='Sidebar' className="sidebar">
      <div className="sidebar-header">🧠 RapidMind</div>
      <ul className="sidebar-nav">
        <li><Link to="/new-chat" id="new-chat"><FaPlus /> Nouveau chat</Link></li>
        <li><Link to="/search-chats" id="search-chats"><FaSearch /> Rechercher des chats</Link></li>
        <li><Link to="/library" id="library"><FaBook /> Bibliothèque</Link></li>
        <li><Link to="/sora" id="sora"><FaRobot /> Sora</Link></li>
        <li><Link to="/gpt" id="gpt"><FaBrain /> GPT</Link></li>
        <li><Link to="/expert-ai" id="expert-ai"><FaUserTie /> Expert AI Consultant</Link></li>
      </ul>

      <Link to="/pricing">
        <button className="upgrade-button"><FaStar style={{ marginRight: '6px', color: 'yellow' }} /> Upgrade to The Plan</button>
      </Link>

      {/* Chat History Section */}
      <h3>Historique</h3>
      <ul className="chat-history">
        {filteredHistory.map(chat => (
          <li key={chat.id} onClick={() => onSelect(chat)} style={{ position: 'relative', backgroundColor: chat.name.toLowerCase().includes(currentPrompt.toLowerCase()) ? '#e0f7fa' : 'transparent' }}>
            {chat.name}
            <button
              className="menu-button"
              onClick={(e) => {
                e.stopPropagation();
                toggleMenu(chat.id);
              }}
              aria-label="Open menu"
              style={{ marginLeft: '8px', background: 'none', border: 'none', cursor: 'pointer' }}
            >
              <FaEllipsisV />
            </button>
            {menuOpenId === chat.id && (
              <div className="menu-dropdown" ref={menuRef} style={{
                position: 'absolute',
                top: '100%',
                right: 0,
                backgroundColor: 'white',
                border: '1px solid #ccc',
                boxShadow: '0 2px 5px rgba(0,0,0,0.15)',
                zIndex: 1000,
                minWidth: '140px',
                padding: '8px 0',
                borderRadius: '4px'
              }}>
                <button className="menu-item delete-button" onClick={() => handleDelete(chat.id)} style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', padding: '8px 16px', background: 'none', border: 'none', textAlign: 'left', cursor: 'pointer' }}>
                  <FaTrash /> Delete
                </button>
                {!chat.saved && (
                  <button className="menu-item save-button" onClick={() => handleSave(chat.id)} style={{ display: 'flex', alignItems: 'center', gap: '8px', width: '100%', padding: '8px 16px', background: 'none', border: 'none', textAlign: 'left', cursor: 'pointer' }}>
                    <FaSave /> Save
                  </button>
                )}
              </div>
            )}
          </li>
        ))}
      </ul>
    </aside>
  );
}

export default Sidebar;
